"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
function useDebounce(callback, deps, debounceMs = 1000, options = {}) {
    return (0, react_1.useCallback)((0, lodash_1.debounce)(callback, debounceMs, options), deps);
}
exports.default = useDebounce;
